export class DocumentUploadType {
  constructor() {
    this.id;
    this.name;
    this.is_active;
  }
  Initialise(initialiser) {
    const documentUploadType = new DocumentUploadType();
    documentUploadType.id = initialiser.id ? initialiser.id : '';
    documentUploadType.name = initialiser.name ? initialiser.name : '';
    documentUploadType.is_active = initialiser.is_active
      ? initialiser.is_active
      : '';
    return documentUploadType;
  }
  MapData(documentUploadType) {
    if (documentUploadType && documentUploadType.length > 0) {
    }
    return documentUploadType;
  }
}
